<template>
  <div class="layout-wrapper">
    <TheHeader />

    <div
      v-if="!isLeasing"
      class="is-flex is-justify-content-center is-hidden-touch"
    >
      <div class="usp-element">
        <b-icon
          icon-pack="fa"
          icon="check-double"
          type="is-white"
          class="mr-2"
        ></b-icon>

        <span class="has-text-white">{{ $t("af:header.title.usp_1") }}</span>
      </div>
      <div class="usp-element">
        <b-icon
          icon-pack="fa"
          icon="check-double"
          type="is-white"
          class="mr-2"
        ></b-icon>

        <span class="has-text-white">{{ $t("af:header.title.usp_2") }}</span>
      </div>
      <div class="usp-element">
        <b-icon
          icon-pack="fa"
          icon="check-double"
          type="is-white"
          class="mr-2"
        ></b-icon>

        <span class="has-text-white">{{ $t("af:header.title.usp_3") }}</span>
      </div>
    </div>

    <div class="is-flex is-justify-content-center">
      <div class="af-container" v-if="hasDefaultOffer && !isLeasing">
        <div class="offer-tile">
          <SelectedOffer />
        </div>
      </div>

      <div class="af-container">
        <slot />
      </div>
    </div>

    <TheFooter />
  </div>
</template>

<script>
export default {
  name: "AppLayoutRegisterLogin",
  components: {
    TheHeader: () => import("@/components/TheHeader"),
    TheFooter: () => import("@/components/TheFooter"),
    SelectedOffer: () => import("@/components/SelectedOffer"),
  },
  computed: {
    hasDefaultOffer() {
      return !!this.$route.query.offer;
    },
    isLeasing() {
      return /^\/leasing.*/i.test(this.$route.path);
    },
  },
};
</script>

<style scoped lang="scss">
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-wrap: nowrap;
  flex-basis: 0;
  flex-direction: column;

  .af-container {
    flex-grow: 1;
    max-width: 560px;
    width: 100%;

    .offer-tile {
      max-width: 400px;
      background-image: none;
      margin-right: 2rem;
      height: initial;
    }

    .offer-card {
      width: auto;
      height: auto;
    }

    .action-tile {
      max-width: 400px;
      margin-top: initial;
    }
  }
}

.usp-element {
  padding: 10px;
}

@media only screen and (min-width: 769px) {
  .layout-wrapper {
    background-image: url("../assets/images/background-sport-car.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .af-container {
    margin-top: 4rem !important;
  }
}
</style>
